import { InjectionToken } from '@angular/core';

export const FREELANCER_CONTRACTS_BASE_URL_PROVIDER = new InjectionToken<
  string | undefined
>('FreelancerContractsBaseUrlProvider');
